import OrderCard from './components/OrderCard/OrderCard.css';
import Account from './components/Account/Account.css';
import UserCard from './components/UserCard/UserCard.css';
import AccountModule from './components/AccountModule/AccountModule.css';
import TravelCompanions from './components/TravelCompanions/TravelCompanions.css';
import PassengerSwitch from './components/Passenger/Switch/Switch.css';
import LoginPage from './components/LoginPage/LoginPage.css';
import Contacts from './components/Contacts/Contacts.css';
import Traveller from './components/Traveller/Traveller.css';
const accountTheme = {
    OrderCard: {
        OrderPreview: {
            main_city: OrderCard.orderPreview__mainCity,
            city: OrderCard.orderPreview__city,
            period: OrderCard.orderPreview__period,
            overlay: OrderCard.orderPreview__overlay,
            root: OrderCard.orderPreview__root
        },
        OrderBooking: {
            root: OrderCard.orderBooking__root,
            type_account: OrderCard.orderBooking__typeAccount
        },
        OrderCard: {
            root: OrderCard.orderCard__root
        },
        PaymentStatus: {
            root: OrderCard.paymentStatus__root,
            account: OrderCard.paymentStatus__account
        }
    },
    Account: {
        NextFlight: {
            checkin: Account.nextFlight__checkin
        }
    },
    UserCard: {
        UserCard: {
            name: UserCard.userCard__name,
            companion: UserCard.userCard__companion,
            empty: UserCard.userCard__empty,
            avatar: UserCard.userCard__avatar
        }
    },
    AccountModule: {
        Account: {
            container__title: AccountModule.account__containerTitle,
            loginWrapper: AccountModule.account__loginWrapper,
            wrapper: AccountModule.account__wrapper
        }
    },
    TravelCompanions: {
        TravelCompanions: {
            companions: TravelCompanions.travelCompanions__companions
        }
    },
    Passenger: {
        Switch: {
            element: PassengerSwitch.element,
            element_active: PassengerSwitch.element_active,
            element_error: PassengerSwitch.element_error
        }
    },
    LoginPage: {
        SubmitButton: {
            root: LoginPage.submitButton__root
        },
        CodeForm: {
            resend__label: LoginPage.codeForm__resendLabel
        }
    },
    Contacts: {
        ResendStyles: {
            sending: Contacts.resendStyles__sending,
            sent: Contacts.resendStyles__sent
        }
    },
    Traveller: {
        Traveller: {
            wrapper: Traveller.wrapper
        }
    }
};
export default accountTheme;
